import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { ContactConsultationView } from '@/components/pages/contact/consultation/ContactConsultationView/ContactConsultationView';
import Layout from '@/container/Layout';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { RECRUITMENT_TYPE_CAREFULLY } from '@/define/consts/consultation';
import { useKanaEffect, useKanaRef } from '@/helpers/use/useKana';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { contactConsultationConfirmPath, contactPath, contactConsultationPath, getAbsolutePath, } from '@/utils/router/links';
const title = 'コンサル選定のご相談 - 入力｜PROFFIT';
const description = 'コンサル選定に向けてヒアリングを実施し、活用のアドバイスをしながら、依頼事項を明確に整理します。';
/**
 * コンサル選定のご相談ページ
 */
export const ContactConsultationPage = (props) => {
    const { changeFormState, formState, month, year } = props;
    const history = useNavigate();
    const kanaRef = useKanaRef();
    useKanaEffect(kanaRef, '#last_name', '#first_name');
    const onSubmit = useCallback((values) => {
        var _a, _b, _c, _d;
        changeFormState(Object.assign(Object.assign({}, values), {
            first_name_kana: ((_b = (_a = kanaRef.current) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b.getFurigana()) || '',
            last_name_kana: ((_d = (_c = kanaRef.current) === null || _c === void 0 ? void 0 : _c.last) === null || _d === void 0 ? void 0 : _d.getFurigana()) || '',
        }));
        history.push(contactConsultationConfirmPath());
    }, [changeFormState, history, kanaRef]);
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        { link: contactPath(), text: 'お問い合わせ' },
        { text: 'コンサル選定のご相談' },
    ], []);
    const initialValues = useMemo(() => {
        if (formState) {
            return formState;
        }
        return {
            budget_type: 2,
            consideration_end_month: month,
            consideration_end_year: year,
            consideration_type: 1,
            recruitment_type: RECRUITMENT_TYPE_CAREFULLY,
        };
    }, [formState, month, year]);
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main client_mypage') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactConsultationPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(ContactConsultationView, { className: 'mb-80', initialValues: initialValues, month: month, onSubmit: onSubmit, year: year })] })));
};
